import type { NumberFormatValues } from 'react-number-format'
import {
  MAX_PACKAGING_VOLUME_CM3,
  normalizePackagingItemVolumeCm3Field,
} from '@/shared/components/packaging/packagingItemVolumeCm3'

export {
  formatPackagingVolumeCm3ForInput,
  parsePackagingVolumeCm3Input,
} from '@/shared/components/packaging/packagingItemVolumeCm3'

const MAX_COMPONENT_WEIGHT_GRAMS = 1_000_000

export function isAllowedComponentWeightGramsInput(
  values: NumberFormatValues
): boolean {
  if (values.floatValue === undefined) {
    return true
  }
  if (values.floatValue < 0) {
    return false
  }
  return values.floatValue <= MAX_COMPONENT_WEIGHT_GRAMS
}

export function isAllowedComponentRecyclingPctInput(
  values: NumberFormatValues
): boolean {
  if (values.floatValue === undefined) {
    return true
  }
  return values.floatValue >= 0 && values.floatValue <= 100
}

export function isAllowedPackagingVolumeCm3Input(
  values: NumberFormatValues
): boolean {
  if (values.floatValue === undefined) {
    return true
  }
  if (values.floatValue < 0) {
    return false
  }
  return values.floatValue <= MAX_PACKAGING_VOLUME_CM3
}

export function isValidPackagingVolumeCm3Input(value: string): boolean {
  const trimmed = value.trim()
  if (trimmed === '') {
    return true
  }
  return normalizePackagingItemVolumeCm3Field(trimmed) !== null
}
